import { BASE_SANITIZE_OPTIONS } from '@/lib/utils/text-utils'
import { VIMEO_IFRAME_HOSTNAME, YOUTUBE_IFRAME_HOSTNAME } from '@/lib/video/video.constants'
import type { IOptions } from 'sanitize-html'

export const REFERENCES_PRODUCT_ID = 'references-product'
export const PRODUCT_IMAGE_SIZE_THUMBNAIL = 80
export const PRODUCT_IMAGE_SIZE_MEDIUM = 140
export const PRODUCT_IMAGE_SIZE_MOBILE = 270
export const PRODUCT_IMAGE_SIZE_DESKTOP = 600
export const PRODUCT_IMAGE_SIZE_METADATA = 1200

/**
 * Anchor ID for technical specifications section
 */
export const TECHNICAL_SPECS_ANCHOR_ID = 'technicals'

/**
 * Minimum number of technical specs required to show the anchor link and full specs section
 */
export const TECHNICAL_SPECS_ANCHOR_THRESHOLD = 5

/**
 * Anchor ID for rich description section
 */
export const DESCRIPTION_ANCHOR_ID = 'description'

/**
 * Maximum character length for truncated product description (display threshold)
 */
export const PRODUCT_DESCRIPTION_MAX_LENGTH = 300

/**
 * Translation key for "See More" link in product sections
 */
export const PRODUCT_SEE_MORE_LABEL_KEY = 'generic:actions.seeMore' as const

/**
 * Spacing for product sections with divider
 */
export const PRODUCT_SECTION_SPACING_WITH_DIVIDER = 'mt-3 gap-y-3'

/**
 * Spacing for product sections without divider
 */
export const PRODUCT_SECTION_SPACING_WITHOUT_DIVIDER = 'py-2 gap-y-4 mt-2'

/**
 * Sanitize options for product short description
 */
export const SHORT_DESCRIPTION_SANITIZE_OPTIONS: IOptions = {
  ...BASE_SANITIZE_OPTIONS,
}

/**
 * Detects tags exclusive to EXTENDED_SANITIZE_OPTIONS (img, table, iframe).
 * When present, the description cannot be fully rendered in the short preview section.
 */
export const EXTENDED_CONTENT_REGEX = /<(img|table|iframe)\b/i

/**
 * Extended sanitize options for full rich content
 * Extends SHORT_DESCRIPTION_SANITIZE_OPTIONS to support images, tables, iframes, and embedded content
 */
export const EXTENDED_SANITIZE_OPTIONS: IOptions = {
  ...SHORT_DESCRIPTION_SANITIZE_OPTIONS,
  allowedTags: [
    ...(SHORT_DESCRIPTION_SANITIZE_OPTIONS.allowedTags || []),
    'div',
    'img',
    'table',
    'tbody',
    'thead',
    'tr',
    'td',
    'th',
    'iframe',
  ],
  allowedAttributes: {
    ...SHORT_DESCRIPTION_SANITIZE_OPTIONS.allowedAttributes,
    div: ['style'],
    img: ['alt', 'src', 'title', 'width', 'height', 'style'],
    iframe: ['src', 'width', 'height', 'frameborder', 'allow', 'allowfullscreen'],
    td: ['style'],
    th: ['style'],
  },
  allowedIframeHostnames: [VIMEO_IFRAME_HOSTNAME, YOUTUBE_IFRAME_HOSTNAME],
}
